import * as React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Suspense } from "react";
import Settings from "../components/settings/settings";
import Home from "../components/home/home";
import PainelAtendimento from "../components/painel-atendimento/painel-atendimento";
import Agendamento from "../components/agendamento/agendamento";
import MeetingsDataPage from "../components/meetings/meetings";
import MeetingQueue from "../components/meeting-queue/meeting-queue";
import MeetingQueueAuth from "../components/meeting-queue-auth/meeting-queue-auth";
import { LoginRedirect } from "../components/login-redirect/login-redirect";
import AvisoForaHorario from "../components/meeting-queue/queue-cards/aviso-fora-horario/aviso-fora-horario";
import AvisoIndisponivel from "../components/meeting-queue/queue-cards/aviso-indisponivel/aviso-indisponivel";
import AccessDisabled from "../components/meeting-queue/queue-cards/access-disabled/access-disabled";
import QueueLimit from "../components/meeting-queue/queue-cards/queue-limit/queue-limit";
import ServiceUnit from "../components/home/unidade/unidade";
import { MeetingExtensibilityConfiguration } from "../components/meeting-extensibility/config";
import InMeetingPanel from "../components/meeting-extensibility/in-meeting-panel/in-meeting-panel";
import InMeetingAlert from "../components/meeting-extensibility/in-meeting-panel/in-meeting-alert";
import PostMeetingPanel from "../components/meeting-extensibility/post-meeting-panel/post-meeting-panel";
import Acs from "../components/acs/acs";
import UploadDocument from "../components/upload-document/upload-document";
import ErrorPage from "../components/error/errorPage";
import SignInPage from "../components/signin/signin";
import SignInSimpleStart from "../components/signin/signin-start";
import SignInSimpleEnd from "../components/signin/signin-end";

export const AppRoute: React.FunctionComponent<{}> = () => {
    return (
        <Suspense fallback={<div></div>}>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/list-serventias" component={Home} />
                    <Route exact path="/painel-atendimento" component={PainelAtendimento} />
                    <Route exact path="/painel-atendimento/:id/:title" component={PainelAtendimento} />
                    <Route exact path="/agendamento" component={Agendamento} />
                    <Route exact path="/form-balcao-virtual" component={ServiceUnit} />
                    <Route exact path="/form-balcao-virtual/:id" component={ServiceUnit} />
                    <Route exact path="/settings" component={Settings} />
                    <Route exact path="/settings/:id" component={Settings} />
                    <Route exact path="/config-meeting-extensibility" component={MeetingExtensibilityConfiguration} />
                    <Route exact path="/in-meeting-panel" component={InMeetingPanel} />
                    <Route exact path="/in-meeting-alert" component={InMeetingAlert} />
                    <Route exact path="/post-meeting-panel" component={PostMeetingPanel} />
                    <Route exact path="/post-meeting-panel/:id/:ancora" component={PostMeetingPanel} />
                    <Route exact path="/errorpage" component={ErrorPage} />
                    <Route exact path="/errorpage/:message" component={ErrorPage} />
                    <Route exact path="/signin" component={SignInPage} />
                    <Route exact path="/signin-simple-start" component={SignInSimpleStart} />
                    <Route exact path="/signin-simple-end" component={SignInSimpleEnd} />
                    <Route path="/upload-document" component={UploadDocument} />
                </Switch>
            </BrowserRouter>
        </Suspense>
    );
};

export const AppAnonymousRoute: React.FunctionComponent<{}> = () => {
    return (
        <Suspense fallback={<div></div>}>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/" component={MeetingsDataPage} />
                    <Route path="/meeting-queue" component={MeetingQueue} />
                    <Route path="/meeting-queue-auth" component={MeetingQueueAuth} />
                    <Route path="/acs" component={Acs} />
                    <Route path="/login-redirect" component={LoginRedirect} />
                    <Route path="/aviso-fora-horario" component={AvisoForaHorario} />
                    <Route path="/aviso-indisponivel" component={AvisoIndisponivel} />
                    <Route path="/aviso-limite-fila" component={QueueLimit} />
                    <Route path="/aviso-acesso-desabilitado" component={AccessDisabled} />
                    <Route path="/meetings" component={MeetingsDataPage} />
                    <Route exact path="/errorpage" component={ErrorPage} />
                </Switch>
            </BrowserRouter>
        </Suspense>
    );
};